function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M-1285-1330H635V713h-1920z"
}), React.createElement("path", {
  d: "M-1285-1034H635V636h-1920z"
}), React.createElement("g", {
  transform: "translate(-70 -52)"
}, React.createElement("path", {
  d: "M103.906 85.116c3.98 0 7.599 2.076 9.681 5.555l8.752 14.615c.206.345.215.778.022 1.132a1.086 1.086 0 0 1-.952.573H86.404c-.396 0-.76-.22-.953-.573a1.144 1.144 0 0 1 .023-1.132l8.751-14.615c2.083-3.479 5.702-5.555 9.681-5.555zm0 2.238c-3.215 0-6.139 1.678-7.821 4.488l-7.73 12.91h31.103l-7.73-12.91c-1.683-2.81-4.607-4.488-7.822-4.488zm-.045 13.075.128.003c.48.037.9.401.99.878.103.495-.171 1.01-.63 1.214-.44.195-.972.073-1.281-.295a1.106 1.106 0 0 1-.128-1.222c.201-.378.622-.609 1.05-.575zm-8.75 0 .128.003c.48.037.9.401.99.878.103.495-.171 1.01-.63 1.214-.44.195-.972.073-1.281-.295a1.106 1.106 0 0 1-.128-1.222c.201-.378.622-.609 1.05-.575zm3.865-6.414c.393-.23.898-.191 1.251.097.401.326.513.907.271 1.362a1.105 1.105 0 0 1-1.196.555c-.45-.098-.8-.478-.856-.936-.054-.427.16-.86.53-1.078zm-3.76-8.897c.485.027.9.38 1.008.853.097.426-.08.885-.439 1.135-.396.276-.95.265-1.324-.048a1.104 1.104 0 0 1-.284-1.34 1.105 1.105 0 0 1 1.04-.6zm28.318-15.315c.61 0 1.153.537 1.153 1.11v7.542c0 .572-.494 1.036-1.104 1.036h-20.96c-2.264 0-4.393-.827-5.995-2.329a8.324 8.324 0 0 1-.357-.356v5.086c0 .572-.494 1.036-1.104 1.036-.61 0-1.105-.464-1.105-1.036V70.84c0-.573.495-1.037 1.105-1.037zm-24.956 2.073h-2.214c.086 1.444.726 2.79 1.825 3.82 1.185 1.11 2.76 1.723 4.435 1.723 3.337 0 6.072-2.457 6.26-5.543h-2.215c-.182 1.943-1.927 3.473-4.045 3.473-2.12 0-3.863-1.53-4.046-3.473zm23.851 0h-11.334c-.098 2.192-1.146 4.158-2.768 5.543h14.102v-2.07h-8.41c-.61 0-1.104-.464-1.104-1.036 0-.572.495-1.036 1.104-1.036h8.41v-1.401zm-17.987 0h-3.637c.168.797.92 1.4 1.819 1.4.899 0 1.65-.603 1.818-1.4z",
  fill: "currentColor"
})), React.createElement("text", {
  fontFamily: "BNPPSans, BNPP Sans",
  fontSize: 16,
  transform: "translate(-70 -56.72)"
}, React.createElement("tspan", {
  x: 78.864,
  y: 138.719
}, "Trociny")));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 70,
    height: 71
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/trociny.9412b0a5.svg";
export { SvgComponent as ReactComponent };